import React from 'react';
import '../styles/App.css';

import {ProgressBar} from './SVGCollection'

class Tab extends React.Component {

    render() {
        return(
            <div ref={this.props.reference} className='tab' onClick={this.props.onClick}>
                <div className='row' style={{display: 'block'}}>
                    <div className='col'><this.props.icon /></div>
                    <div className='col d-flex justify-content-center'><ProgressBar progressPercentage={this.props.progressPercentage} /> </div>
                </div>
            </div>
        )
    }
}

export default Tab;
